import { render, staticRenderFns } from "./BookingAdd.vue?vue&type=template&id=527bbf54&scoped=true"
import script from "./BookingAdd.vue?vue&type=script&lang=js"
export * from "./BookingAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527bbf54",
  null
  
)

export default component.exports